<template>
    <div>
        <!-- Modal Edição da Data da Movimentação -->
        <div class="modal fade" id="dataMovEditModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Editar Data da Movimentação</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body" v-if="dados">
                        <az-input
                            v-model="dados.data"
                            label="Data da Movimentação"
                            type="date"
                            required
                            :validate="validate" />

                        <pre v-if="false">{{ dados }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return {
            dados: null, 
            validate: false, 
        }
    },

    props: [
        'id_fatura'
    ],

    components: {
        AzInput,
        AzSubmit,
    },

    methods: {
        abrir(item, grupo) { 
            this.dados = { 
                item: item,
                data: grupo, 
                id_fatura: this.id_fatura,
            };

            $('#dataMovEditModal').modal('show');
        },
        
        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'faturas', 
                func: 'atualizar_data_mov', 
                dados: this.dados, 
                toast: true, 
                modal: 'dataMovEditModal',
                callback: () => {
                    this.$emit('refresh');
                }
            });
        },
    }
}
</script>
